import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import CreatePage from './pages/CreatePage';
import MyPodcastsPage from './pages/MyPodcastsPage';
import TeamListPage from './pages/teams/TeamListPage';
import CreateTeamPage from './pages/teams/CreateTeamPage';
import EditTeamPage from './pages/teams/EditTeamPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import FAQPage from './pages/FAQPage';
import Footer from './components/Footer';
import { AuthProvider } from './context/AuthContext';
import './index.css';
import PodcastPublicPage from './pages/PodcastPublicPage';
import PodcastPrivatePage from './pages/PodcastPrivatePage';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App flex flex-col min-h-screen">
          <Navbar />
          <main className="flex-grow bg-gray-50">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/create" element={<CreatePage />} />
              <Route path="/my-podcasts" element={<ProtectedRoute><MyPodcastsPage /></ProtectedRoute>} />
              <Route path="/my-podcasts/:podcastId" element={<ProtectedRoute><PodcastPrivatePage /></ProtectedRoute>} />
              <Route path="/p/:shareId" element={<PodcastPublicPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/terms" element={<TermsOfServicePage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/teams" element={<ProtectedRoute><TeamListPage /></ProtectedRoute>} />
              <Route path="/teams/new" element={<ProtectedRoute><CreateTeamPage /></ProtectedRoute>} />
              <Route path="/teams/edit/:id" element={<ProtectedRoute><EditTeamPage /></ProtectedRoute>} />
            </Routes>
          </main>
          <Footer className="mt-auto" />
        </div>
        <Analytics />
        <SpeedInsights />
      </Router>
    </AuthProvider>
  );
}

export default App;
